export default __webpack_public_path__ + "static/VIDA_GRUPO-138d49289847c6c356d34c2fc6dab0e6.jpg";